import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import useGSAP from './hooks/useGSAP';
import Loader from './components/Loader';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import ChiSiamoPage from './pages/ChiSiamoPage';
import NotiziePage from './pages/NotiziePage';
import ArticoloPage from './pages/ArticoloPage';
import EventiPage from './pages/EventiPage';
import EventoPage from './pages/EventoPage';
import CircoliPage from './pages/CircoliPage';
import CircoloPage from './pages/CircoloPage';
import FederazioniPage from './pages/FederazioniPage';
import FederazioniRegionaliPage from './pages/FederazioniRegionaliPage';
import FederazionePage from './pages/FederazionePage';
import PersonePage from './pages/PersonePage';
import PersonaDettaglioPage from './pages/PersonaDettaglioPage';
import SegreteriaPage from './pages/SegreteriaPage';
import SegretariPage from './pages/SegretariPage';
import ElettiPage from './pages/ElettiPage';
import OrganizzazionePage from './pages/OrganizzazionePage';
import VideoPage from './pages/VideoPage';
import VideoDettaglioPage from './pages/VideoDettaglioPage';
import PodcastPage from './pages/PodcastPage';
import PercheGDPage from './pages/PercheGDPage';
import RicercaPage from './pages/RicercaPage';
import ContattiPage from './pages/ContattiPage';
import StampaPage from './pages/StampaPage';
import FaqPage from './pages/FaqPage';
import PartecipaPage from './pages/PartecipaPage';
import AttivitaPage from './pages/AttivitaPage';
import DocumentiPage from './pages/DocumentiPage';
import TemiPage from './pages/TemiPage';
import TematicaPage from './pages/TematicaPage';
import DipartimentiPage from './pages/DipartimentiPage';
import DipartimentoPage from './pages/DipartimentoPage';
import DelegaPage from './pages/DelegaPage';
import CampagnePage from './pages/CampagnePage';
import CampagnaPage from './pages/CampagnaPage';

const AppContent = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoaderComplete = useCallback(() => {
    setIsLoading(false);
  }, []);

  // Init GSAP/Lenis after loading
  useGSAP(isLoading);

  return (
    <>
      {isLoading && <Loader onComplete={handleLoaderComplete} />}
      <div style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/chi-siamo" element={<ChiSiamoPage />} />
          <Route path="/perche-giovani-democratici" element={<PercheGDPage />} />
          <Route path="/notizie" element={<NotiziePage />} />
          <Route path="/articolo" element={<ArticoloPage />} />
          <Route path="/eventi" element={<EventiPage />} />
          <Route path="/evento" element={<EventoPage />} />
          <Route path="/circoli" element={<CircoliPage />} />
          <Route path="/circolo" element={<CircoloPage />} />
          <Route path="/federazioni-regionali" element={<FederazioniRegionaliPage />} />
          <Route path="/federazioni-provinciali" element={<FederazioniPage />} />
          <Route path="/federazioni" element={<FederazioniPage />} />
          <Route path="/federazione" element={<FederazionePage />} />
          <Route path="/persone" element={<PersonePage />} />
          <Route path="/persona-dettaglio" element={<PersonaDettaglioPage />} />
          <Route path="/segreteria" element={<SegreteriaPage />} />
          <Route path="/segretari" element={<SegretariPage />} />
          <Route path="/eletti" element={<ElettiPage />} />
          <Route path="/organizzazione" element={<OrganizzazionePage />} />
          <Route path="/video" element={<VideoPage />} />
          <Route path="/video-dettaglio" element={<VideoDettaglioPage />} />
          <Route path="/podcast" element={<PodcastPage />} />
          <Route path="/ricerca" element={<RicercaPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          <Route path="/stampa" element={<StampaPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/partecipa" element={<PartecipaPage />} />
          <Route path="/attivita" element={<AttivitaPage />} />
          <Route path="/documenti" element={<DocumentiPage />} />
          <Route path="/temi" element={<TemiPage />} />
          <Route path="/tematica" element={<TematicaPage />} />
          <Route path="/dipartimenti" element={<DipartimentiPage />} />
          <Route path="/dipartimento/:id" element={<DipartimentoPage />} />
          <Route path="/delega/:id" element={<DelegaPage />} />
          <Route path="/campagne" element={<CampagnePage />} />
          <Route path="/campagna" element={<CampagnaPage />} />
          {/* Catch-all */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
